export interface IAttributesType {
  [key: string]: string | undefined;
}

export interface ITagDescription {
  tag: string;
  attributes: IAttributesType;
}

export interface ITagDescriptions {
  [key: string]: ITagDescription | null | undefined;
}

export interface ICanonicalTagDescription extends ITagDescription {
  tag: 'link',
  attributes: {
    rel: 'canonical',
    href: string,
  },
}

export const makeCanonicalTagDescription = (href: string): ICanonicalTagDescription => ({
  tag: 'link',
  attributes: {
    rel: 'canonical',
    href,
  },
});

export interface IAlternateTagDescription extends ITagDescription {
  tag: 'link';
  attributes: {
    href: string;
    hrefLang: string;
    rel: 'alternate';
  }
}

export const makeAlternateTagDescription = (href: string, hrefLang: string): IAlternateTagDescription => ({
  tag: 'link',
  attributes: {
    href,
    hrefLang,
    rel: 'alternate',
  },
});

export type AlternateTagDesciptions = Partial<{
  [hrefLang: string]: IAlternateTagDescription;
}>;

export interface IHeadState {
  getTags(): ITagDescriptions;
  setTags(tags: ITagDescriptions): void;
}

export const ID_ATTRIBUTE = 'data-head-tag-manager-id';
